"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_2 = require("react");
var tooltipStyles_1 = require("./tooltipStyles");
var Close_1 = require("@material-ui/icons/Close");
var core_1 = require("@material-ui/core");
var Tooltip = function (_a) {
    var children = _a.children;
    var _b = react_1.useState(true), isVisible = _b[0], setIsVisible = _b[1];
    var styles = tooltipStyles_1.default();
    if (!isVisible) {
        return null;
    }
    return (<div className={styles.tooltipContainer}>
      {children}
      <Close_1.default onClick={function () { return setIsVisible(false); }}/>
      <core_1.Box className={styles.arrow}/>
    </div>);
};
exports.default = Tooltip;
